import React from "react";

const PhoneOverview = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="#F6F8FA" />
      <path
        d="M18.0245 19.0115C18.7283 20.2479 19.7521 21.2717 20.9885 21.9755L21.6515 21.047C21.7581 20.8977 21.9158 20.7927 22.0946 20.7517C22.2734 20.7108 22.4611 20.7369 22.622 20.825C23.6827 21.4047 24.8542 21.7533 26.0592 21.848C26.2473 21.8629 26.4229 21.9482 26.5509 22.0867C26.6789 22.2253 26.75 22.4071 26.75 22.5958V25.9423C26.75 26.1279 26.6812 26.3071 26.5568 26.4449C26.4324 26.5828 26.2612 26.6696 26.0765 26.6885C25.679 26.7297 25.2785 26.75 24.875 26.75C18.455 26.75 13.25 21.545 13.25 15.125C13.25 14.7215 13.2703 14.321 13.3115 13.9235C13.3304 13.7388 13.4172 13.5676 13.5551 13.4432C13.6929 13.3188 13.8721 13.25 14.0578 13.25H17.4042C17.5929 13.25 17.7747 13.3211 17.9133 13.4491C18.0518 13.5771 18.1371 13.7527 18.152 13.9408C18.2467 15.1458 18.5953 16.3173 19.175 17.378C19.2631 17.5389 19.2892 17.7266 19.2483 17.9054C19.2073 18.0842 19.1023 18.2419 18.953 18.3485L18.0245 19.0115ZM16.133 18.5187L17.558 17.501C17.1536 16.6281 16.8765 15.7016 16.7352 14.75H14.7575C14.753 14.8745 14.7507 14.9998 14.7507 15.125C14.75 20.717 19.283 25.25 24.875 25.25C25.0002 25.25 25.1255 25.2478 25.25 25.2425V23.2648C24.2984 23.1235 23.3719 22.8464 22.499 22.442L21.4813 23.867C21.0715 23.7078 20.6735 23.5198 20.2902 23.3045L20.2468 23.2797C18.7757 22.4425 17.5575 21.2243 16.7202 19.7532L16.6955 19.7098C16.4802 19.3265 16.2922 18.9285 16.133 18.5187Z"
        fill="#868C98"
      />
    </svg>
  );
};

export default PhoneOverview;
